import { tourBackButton, tourCustomButton, tourExitButton, tourNextButton } from '../data/tour-buttons';
import { type TourStepDefinition } from '../data/tour-config';
import { TourService } from '../services/tour/tour.service';

export function getHomeTour(tourService: TourService): TourStepDefinition[] {
  return [
    {
      id: 'homeTourIntro',
      buttons: [tourExitButton(tourService, 'Skip Tour'), tourNextButton('Start Tour')],
      title: 'Welcome to Your Patient Portal!',
      text:
        "Let's take a quick tour to help you get the most out of your Memorial Health System patient portal. " +
        "You'll learn how to access your health information, communicate with your care team, and manage your healthcare online.",
      attachTo: {
        element: '#imgLogo',
        //no on provided so overlay displays centered on screen
      },
    },
    {
      id: 'homeTourResults',
      attachTo: {
        element: '#resultsHomeBtn',
        on: 'bottom',
      },
      buttons: [tourExitButton(tourService), tourBackButton('Back', ['mr-auto']), tourNextButton('Next (1 of 7)')],
      title: 'View Your Test Results',
      text: [
        "Access your lab results, imaging reports, and other test findings as soon as they're available. " +
          "You'll receive notifications when new results are ready to view.",
      ],
    },
    {
      id: 'homeTourMedications',
      attachTo: {
        element: '#medicationsHomeBtn',
        on: 'bottom',
      },
      buttons: [tourExitButton(tourService), tourBackButton('Back', ['mr-auto']), tourNextButton('Next (2 of 7)')],
      title: 'Manage Your Medications',
      text: [
        'See all your current prescriptions in one place, request refills with just a few clicks, ' +
          'and review your complete medication history.',
      ],
    },
    {
      id: 'homeTourMessages',
      attachTo: {
        element: '#messagesHomeBtn',
        on: 'bottom',
      },
      buttons: [tourExitButton(tourService), tourBackButton('Back', ['mr-auto']), tourNextButton('Next (3 of 7)')],
      title: 'Secure Messaging',
      text: [
        'Send secure messages directly to your care team, ask non-urgent questions, and receive replies. ' +
          'All communications are private and HIPAA-compliant.',
      ],
    },
    {
      id: 'homeTourAppointments',
      attachTo: {
        element: '#appointmentsHomeBtn',
        on: 'bottom',
      },
      buttons: [tourExitButton(tourService), tourBackButton('Back', ['mr-auto']), tourNextButton('Next (4 of 7)')],
      title: 'Schedule & Manage Appointments',
      text: [
        'Book new appointments, view upcoming visits, and receive reminders. You can also see the visit notes ' +
          'and summaries from past visits.',
      ],
    },
    {
      id: 'homeTourMedicalRecord',
      attachTo: {
        element: '#medical-recordHomeBtn',
        on: 'bottom',
      },
      buttons: [tourExitButton(tourService), tourBackButton('Back', ['mr-auto']), tourNextButton('Next (5 of 7)')],
      title: 'Your Complete Health Record',
      text: ['Access your comprehensive medical history including diagnoses, immunizations, allergies, and more.'],
    },
    {
      id: 'homeTourBilling',
      attachTo: {
        element: '#billingHomeBtn',
        on: 'bottom',
      },
      buttons: [tourExitButton(tourService), tourBackButton('Back', ['mr-auto']), tourNextButton('Next (6 of 7)')],
      title: 'Manage Your Billing',
      text: ['Links to see statements, make payments online, set up payment plans, and track your billing history.'],
    },
    {
      id: 'homeTourProfile',
      attachTo: {
        element: 'app-profile-widget',
        on: 'top',
      },
      buttons: [tourExitButton(tourService), tourBackButton('Back', ['mr-auto']), tourNextButton('Done (7 of 7)')],
      title: 'Keep Your Information Current',
      text: ['Your profile displays your current contact details, address, phone number, and email.'],
    },
    {
      id: 'homeTourOutro',
      buttons: [
        tourCustomButton('Restart Tour', 'secondary', () => tourService.restart()),
        tourCustomButton('Start Using Portal', 'primary', () => tourService.complete()),
      ],
      title: "You're All Set!",
      text: [
        "You're ready to start using your patient portal. Remember, you can access any of these features at any time from your home screen. ",
      ],
    },
  ];
}
